import React, {useState, useEffect} from 'react'
import { CgMenu, CgClose } from 'react-icons/cg'
import "./MobileSidebar.scss"
import Menu from '../Menu/Menu';
import Social from '../Social/Social';

const MobileSidebar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuContainerClass = `menu-container ${isMenuOpen ? 'show-menu' : ''}`;
  const [isIconSticky, setIsIconSticky] = useState(false);

  const showMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = 10;
      setIsIconSticky(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className='mobile-sidebar container'>
      <div className={menuContainerClass}>
        <Menu closeMenu={closeMenu} />
        <Social /> 
      </div>
      <div className={`toggle-icon ${isIconSticky ? 'sticky-icon' : ''}`} onClick={showMenu}>
        {!isMenuOpen ? <CgMenu className='icon' /> : <CgClose className='icon' />}
      </div>
    </div>
  )
}

export default MobileSidebar